// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34baI","question":"styles_question__1wbtr","description":"styles_description__1FJum"};